import { render, staticRenderFns } from "./addReglement.vue?vue&type=template&id=13d5dc56&"
import script from "./addReglement.vue?vue&type=script&lang=js&"
export * from "./addReglement.vue?vue&type=script&lang=js&"
import style0 from "./addReglement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports